//Librerias
import React, { useState, useEffect, useContext } from "react";
import NumberFormat from "react-number-format";

//Assets
import { BiHelpCircle } from "react-icons/bi";

//Helpers
import { fireAlert, getResume, getRut } from "../../../helpers/autoAtencionHelpers";

//Componentes
import { Table } from "react-bootstrap";
import ModalDesglose from "../../modal/modal-autoatencion/ModalDesglose";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import IconButton from "../../buttons/IconButton";
import { AiOutlineCloudSync } from "react-icons/ai";
import Modalaplicaciones from "../../modal/modal-autoatencion/Modalaplicaciones";
import { api } from "../../../helpers/api";
import { AUTOATENCIONAPI, PORTALSAPI } from "../../../helpers/url";
import { Filterparametros } from "../../../helpers/Filter_parametros";
import { columnasAplicaionCXC, columnasAplicaionDoc, columnasAplicaionLeasing } from "../../../constants/columns_aplicaciones";
import useStorage from "../../../helpers/useStorage";
import { type_aplicaciones } from "../../../constants/typeaplicaciones";
import { formatoNumero, withoutDotsNumber } from "../../../helpers/FormatFecha";
import { ContextAplicacion } from "../../../context/AplicacionesContext";

const Resumen = ({ text = "Resumen", loading = false, reload = null, setObligatorioAplicaciones, isObligatorioAplicaciones, setLoading, Button, rows, handleSubmit }) => {
  const bills = JSON.parse(sessionStorage.getItem("bills"));
  const [amountsObj, setAmountsObj] = useState({});
  const [show, setShow] = useState(false);
  const [showSecciones, setShowSecciones] = useState(false);

  //Columns Aplicaciones
  const { 
    selectAplicacionDoc, 
    setselectAplicacionDoc,
    selectAplicacionCxc, 
    setselectAplicacionCxc,
    selectAplicaionLeasing, 
    setselectAplicaionLeasing,
    rowsLeasing, 
    setRowsLeasing,
    rowsDoc, 
    setRowsDoc,
    rowsCxc, 
    setRowsCxc,
    totalAplicaciones, 
    setTotalAPlicaciones,
    totalAplicacionestable, 
    setTotalAplicacionestable
  } = useContext(ContextAplicacion);

  const [parametros_paa, setParametrospaa] = useState({})
  const [parametros] = useStorage("parametros_comerciales", {}, "session");
  const [ tiposeleccion, setTiposeleccion ] = useState(null);
  const [ showTables, setShowTables ] = useState(false);

  const { ANTICIPO } = JSON.parse(
    sessionStorage.getItem("parametros_comerciales")
  );

  const { anticipo } = JSON.parse(
    sessionStorage.getItem("parametros_indicadores")
  );

  const onClick = async () => {
    try {
      await reload();
      setAmountsObj(getResume());
    } catch (err) {
      console.log(err);
    }
  };

  
  useEffect(()=>{
    handlecheckabono({type:'cuotas', rowsDoc:rowsLeasing.tempRows })
  },[rowsLeasing.tempRows])

  useEffect(()=>{
    handlecheckabono({type:'dt', rowsDoc:rowsDoc.tempRows })
  },[rowsDoc.tempRows])

  useEffect(()=>{
    handlecheckabono({type:'cxc', rowsDoc:rowsCxc.tempRows })
  },[rowsCxc.tempRows])

  useEffect(() => {
    setAmountsObj(getResume());
    getParametros();
  }, []);

  const handlecheckabono = ({type = '', rowsDoc = []}) => {

    switch(type){
      case 'dt':
        let seleccionados = rowsDoc.filter((item)=> item.seleccionado );
        const totalDoc = seleccionados.length > 0 ? seleccionados.map((item)=> Number(item.abono) || 0).reduce((a,b)=> a+b, 0) : 0;
        setTotalAPlicaciones((prev)=>({
          ...prev,
          doc:totalDoc
        }))
        break;
      case 'cxc':
        let seleccionadoscxc = rowsDoc.filter((item)=> item.seleccionado );
        const totalCxc = seleccionadoscxc.length > 0 ? seleccionadoscxc.map((item)=> Number(item.abono) || 0).reduce((a,b)=> a+b, 0) : 0;
        setTotalAPlicaciones((prev)=>({
          ...prev,
          cxc:totalCxc
        }))
        
        break;
      case 'cuotas':
        let seleccionadoscuotas = rowsDoc.filter((item)=> item.seleccionado );
        const totalCuotas = seleccionadoscuotas.length > 0 ? seleccionadoscuotas.map((item)=> Number(item.abono) || 0).reduce((a,b)=> a+b, 0) : 0;
        setTotalAPlicaciones((prev)=>({
          ...prev,
          cuotas:totalCuotas
        }))
        break;
    }
  }

  const getParametros = async(isFisrt = true)=>{
    try{

      const parametro = Filterparametros(parametros)
      setParametrospaa(parametro) 

      if( rowsLeasing.tempRows.length > 0 || rowsDoc.tempRows.length > 0 || rowsCxc.tempRows.length > 0 ){
        handleSaveLocalstorage();
        //Se filtar por todos
        setTiposeleccion(2);
        return;
      };

      //Loading
      setLoading(true);

      //Limpiar el localstorage 
      localStorage.setItem('aplicaciones', JSON.stringify([]))
     
      const rut_cliente = await getRut();
      const resp_listapli = await api.get(PORTALSAPI.GET.LISTARAPLICACIONCLIENTEPORTAL.replace("{rut}", rut_cliente));

      const newDataDoc = resp_listapli?.data?.documentos?.map((item, id)=>({...item, index:id, seleccionado: false, tipo:0 })) || []
      const newDataCxc = resp_listapli?.data?.cxc?.map((item, id)=>({...item, index:id, seleccionado: false, tipo:1 })) || []
      const newDataCuotas = resp_listapli?.data?.cuotas?.map((item, id)=>({...item, index:id, seleccionado: false })) || []

      const isObligatorioDoc = newDataDoc.some((item)=> item?.obligatorio);
      const isObligatorioCxc = newDataCxc.some((item)=> item?.obligatorio);
      const isObligatorioCuotas = newDataCuotas.some((item)=> item?.obligatorio);

      setRowsDoc({
        columns: columnasAplicaionDoc({ selectAplicacionDoc: selectAplicacionDoc, setRowsDoc: setRowsDoc, rowsDoc: newDataDoc, tempRows: newDataDoc}),
        rows: newDataDoc,
        tempRows: newDataDoc
      })

      setRowsCxc({
        columns: columnasAplicaionCXC({ selectAplicacionCxc: selectAplicacionCxc, setRowsCxc: setRowsCxc, rowsCxc: newDataCxc, tempRows: newDataCxc }),
        rows: newDataCxc,
        tempRows: newDataCxc
      })
 
      setRowsLeasing({
        columns: columnasAplicaionLeasing({ selectAplicaionLeasing: selectAplicaionLeasing, setRowsLeasing:setRowsLeasing, rowsLeasing: newDataCuotas, tempRows: newDataCuotas}),
        rows: newDataCuotas,
        tempRows: newDataCuotas
      })

      //Para documento , Falta cuotas y CXC
      if( isFisrt ){
        if( isObligatorioDoc){
          await handleAlertObligatorio(parametro.mensaje_general_1, parametro.mensaje_validacion_1 );
          return;
        }
  
        if( isObligatorioCxc){
          await handleAlertObligatorio(parametro.mensaje_general_1, parametro.mensaje_validacion_2 );
          return;
        } 
  
        if( isObligatorioCuotas){
          await handleAlertObligatorio(parametro.mensaje_general_1, parametro.mensaje_validacion_3 );
          return;
        }
      }

      if( (parametro.is_app_cxc && newDataCxc.length > 0 ) || 
          (parametro.is_app_dte && newDataDoc.length > 0) || 
          (parametro.is_app_lesing && newDataCuotas.length > 0) ){

            setShowSecciones(true)
          }
          //Se filtar por todos
          setTiposeleccion(2)
          
    }catch(e){
      console.log("🚀 ~ getParametros ~ e:", e)

    }finally{
      setLoading(false);
    }
  }

  const handleAlertObligatorio = async(title = '', text = '')=>{
    await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title:'', text: title+' '+text });
    setShowSecciones(true)
    //Se filtar por todos
    setTiposeleccion(2)
  }

  useEffect(()=>{
    if( tiposeleccion == null)return;
    hanleFilterTable();
  },[tiposeleccion])

  const hanleFilterTable = ()=>{
    setShowTables(false);

    let newDataDoc = rowsDoc.tempRows;
    let newDataCxc = rowsCxc.tempRows;
    let newDataCuotas = rowsLeasing.tempRows;

    if( tiposeleccion == type_aplicaciones.OBLIGATORIO ){
      newDataDoc = newDataDoc.filter((item)=> item.obligatorio);
      newDataCxc = newDataCxc.filter((item)=> item.obligatorio);
      newDataCuotas = newDataCuotas.filter((item)=> item.obligatorio);
    }else{
      newDataDoc = newDataDoc.filter((item)=> item.obligatorio || !item.obligatorio);
      newDataCxc = newDataCxc.filter((item)=> item.obligatorio || !item.obligatorio);
      newDataCuotas = newDataCuotas.filter((item)=> item.obligatorio || !item.obligatorio);
    }

    setRowsDoc((prev)=>({
      ...prev,
      columns: columnasAplicaionDoc({ selectAplicacionDoc: selectAplicacionDoc, setRowsDoc: setRowsDoc, rowsDoc: newDataDoc, tempRows: rowsDoc.tempRows }),
      rows: newDataDoc
    }))

    setRowsCxc((prev)=>({
      ...prev,
      columns: columnasAplicaionCXC({ selectAplicacionCxc: selectAplicacionCxc, setRowsCxc: setRowsCxc, rowsCxc: newDataCxc, tempRows: rowsCxc.tempRows }),
      rows: newDataCxc
    }))

    setRowsLeasing((prev)=>({
      ...prev,
      columns: columnasAplicaionLeasing({ selectAplicaionLeasing: selectAplicaionLeasing, setRowsLeasing:setRowsLeasing, rowsLeasing: newDataCuotas, tempRows: rowsLeasing.tempRows }),
      rows: newDataCuotas
    }))

    setTimeout(()=>{
      setShowTables(true);
    }, 500)
    
  }

  const handleSaveAplicaciones = async()=>{
    const totalAplicacion = totalAplicaciones.cuotas + totalAplicaciones.cxc + totalAplicaciones.doc;

    //Valitar si no ha seleccionado aplicaiones pendientes
    const dte_select_obligatorio = rowsDoc.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item.pagoTransito == 0);
    const dte_obligatorio = rowsDoc.tempRows.filter((item)=> item.obligatorio && item.pagoTransito == 0);

    const cxc_select_obligatorio = rowsCxc.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item.pagoTransito == 0);
    const cxc_obligatorio = rowsCxc.tempRows.filter((item)=> item.obligatorio && item.pagoTransito == 0); 

    const cuotas_select_obligatorio = rowsLeasing.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item?.pago_transito == 0);
    const cuotas_obligatorio = rowsLeasing.tempRows.filter((item)=> item.obligatorio && item?.pago_transito == 0);

    const liquido_pagar = (amountsObj.liquid - totalAplicacion);

    if( liquido_pagar > 0 ){
      if( ( parametros_paa.is_app_dte && rowsDoc.tempRows.length > 0 && dte_select_obligatorio.length == 0 && dte_obligatorio.length > 0) || 
          ( parametros_paa.is_app_cxc && rowsCxc.tempRows.length > 0 && cxc_select_obligatorio.length == 0 && cxc_obligatorio.length > 0) || 
          ( parametros_paa.is_app_lesing && rowsLeasing.tempRows.length > 0 && cuotas_select_obligatorio.length == 0 && cuotas_obligatorio.length > 0) ){
        await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: 'Tiene aplicaciones obligatorias pendientes de realizar, favor aplicar para poder continuar' });
        return;
      }
    }

    const text = await validateAplicaciones();

    if(text != ''){
      await fireAlert({ timer: 5000, icon: "warning", button: "OK", title:'', text:text });
      return;
    }
  
    if( totalAplicacion > amountsObj.liquid ){
      await fireAlert({ timer: 5000, icon: "warning", button: "OK", title:'', text:'El importe es mayor al liquido a pagar' });
      return;
    }

    //Agregar total de aplicaciones
    setTotalAplicacionestable(totalAplicacion)
    //Cerrar modal
    setShowSecciones(false)

    handleSaveLocalstorage();
  }

  const handleSaveLocalstorage = ()=>{
    const aplicaciones = {
      appdocumentos: rowsDoc.tempRows.filter((item)=> item.seleccionado).map((item)=>({ ...item, abono: withoutDotsNumber(formatoNumero(item.abono)).toString() })),
      appcxc: rowsCxc.tempRows.filter((item)=> item.seleccionado).map((item)=>({ ...item, abono: withoutDotsNumber(formatoNumero(item.abono)).toString() })),
      appcuotas: rowsLeasing.tempRows.filter((item)=> item.seleccionado).map((item)=>({ ...item, abono: withoutDotsNumber(formatoNumero(item.abono)).toString() })),
    }

    localStorage.setItem('aplicaciones', JSON.stringify(aplicaciones))
  }

  const validateAplicaciones = ()=>{
    return new Promise((resolve, reject)=>{
      let text = '';
      if( rowsDoc.tempRows.length > 0){
        rowsDoc.tempRows.forEach((row) => {
          if( row.seleccionado ){
            if ( parseFloat(row.mora) === 0 && parseFloat(row?.abono || 0) === 0) {
              text = "El abono debe ser mayor a 0";
            }
            if (
              parseFloat(row.mora) > 0 &&
              parseFloat(row.abono || 0) < parseFloat(row.mora)
            ) {
              text = "El abono debe ser mayor o igual a la mora";
            }

            if( parseFloat(row?.abono || 0) > (parseFloat(row?.saldoPendiente)+parseFloat(row.mora)) ){
              text = `El abono para el documento #${row?.nroDoc} no debe ser mayor al total permitido`;
            }
          }
        })
      } 
  
      if(rowsCxc.tempRows.length > 0){
        rowsCxc.tempRows.forEach((rowCxC) => {
          if( rowCxC.seleccionado ){
            if (parseFloat(rowCxC.abono || 0) === 0) {
              text = "El abono debe ser mayor a 0";
            }
            if( parseFloat(rowCxC?.abono || 0) > parseFloat(rowCxC?.saldo) ){
              text = `El abono para el cuenta #${rowCxC?.cxC_NUM_CTA} no debe ser mayor al total permitido`;
            }
          }
        });
      }
   
      if(rowsLeasing.tempRows.length > 0){
        rowsLeasing.tempRows.forEach((rowCL) => {
          if( rowCL.seleccionado ){
            if (parseFloat(rowCL.abono || 0) === 0) {
              text = "El abono debe ser mayor a 0";
            }
            if( parseFloat(rowCL?.abono || 0) > parseFloat(rowCL?.total_a_pagar) ){
              text = `El abono para la cuota #${rowCL?.num_cuota} no debe ser mayor al total permitido`;
            }
          }
        });
      }

      resolve(text);

    })
    
  }

  const handleCloseModal = async()=>{
    //Cerrar modal
    setShowSecciones(false);
  }

  const handleShowModal = () =>{
    setShowSecciones(true);
  }

  const handleClickbutton = async()=>{

    const liquido_pagar = (amountsObj.liquid - totalAplicacionestable)

    const dte_select_obligatorio = rowsDoc.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item.pagoTransito == 0);
    const dte_obligatorio = rowsDoc.tempRows.filter((item)=> item.obligatorio && item.pagoTransito == 0);

    const cxc_select_obligatorio = rowsCxc.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item.pagoTransito == 0);
    const cxc_obligatorio = rowsCxc.tempRows.filter((item)=> item.obligatorio && item.pagoTransito == 0); 

    const cuotas_select_obligatorio = rowsLeasing.tempRows.filter((item)=> item.seleccionado).filter((item)=> item.obligatorio && item?.pago_transito == 0);
    const cuotas_obligatorio = rowsLeasing.tempRows.filter((item)=> item.obligatorio && item?.pago_transito == 0);

    // != dte_obligatorio.length
    // != cxc_obligatorio.length
    // != cuotas_obligatorio.length

    //Validar si hay obligatorios pendientes
    if( liquido_pagar > 0 ){
      if( rowsDoc.tempRows.length > 0 && dte_select_obligatorio.length == 0 && dte_obligatorio.length > 0 ){
        await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_general_1 +' '+ parametros_paa.mensaje_app_dte });
        return;
      }
      
      if(rowsCxc.tempRows.length > 0 && cxc_select_obligatorio.length == 0 && cxc_obligatorio.length > 0){
        await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_general_1 +' '+ parametros_paa.mensaje_app_cxp });
        return;
      } 
      
      if(rowsLeasing.tempRows.length > 0 && cuotas_select_obligatorio.length == 0 && cuotas_obligatorio.length > 0){
        await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_general_1 +' '+ parametros_paa.mensaje_app_leasing });
        return;
      }
    }

    // != dte_obligatorio.length
    // != cxc_obligatorio.length
    // != cuotas_obligatorio.length

    //Con liquido y aplicaciones pendientes
    if( liquido_pagar > 0 && dte_select_obligatorio.length == 0 && dte_obligatorio.length > 0 ){
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_validacion_1 });
      return;
    }

    if(liquido_pagar > 0 && cxc_select_obligatorio.length == 0 && cxc_obligatorio.length > 0){
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_validacion_2 });
      return;
    }

    if(liquido_pagar > 0 && cuotas_select_obligatorio.length == 0 && cuotas_obligatorio.length > 0){
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_validacion_3 });
      return;
    }

    const dte_select_no_obligatorio = rowsDoc.tempRows.filter((item)=> item.seleccionado).filter((item)=> !item.obligatorio);
    const cxc_select_no_obligatorio = rowsCxc.tempRows.filter((item)=> item.seleccionado).filter((item)=> !item.obligatorio);
    const cuotas_select_no_obligatorio = rowsLeasing.tempRows.filter((item)=> item.seleccionado).filter((item)=> !item.obligatorio);

    //Si sobra liquido a pagar y si ese liquido se puede abonar en las obligatorias
    const validations = await validateappPendientes();

    if( liquido_pagar > 0 && validations ){
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_general_1 });
      return;
    }

    //Si liquido es 0 y si hay opcionales seleccionados, y obligatorias pendientes
    if(liquido_pagar == 0 && 
      ((dte_select_no_obligatorio.length > 0 ) || 
      (cxc_select_no_obligatorio.length > 0 ) || 
      (cuotas_select_no_obligatorio.length > 0))
      && validations
    ){
      // 'Debe quitar opcionalaes para continuar'
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_validacion_4 });
      return;
    }

    //Si sobra liquido y si hay opcionales seleccionados
    if(liquido_pagar > 0 && 
        ((dte_select_no_obligatorio.length > 0 ) || 
        (cxc_select_no_obligatorio.length > 0 ) || 
        (cuotas_select_no_obligatorio.length > 0)) &&
        validations
    ){
      // 'Debe quitar opcionalaes para continuar'
      await fireAlert({ timer: 5000, icon: "warning", button: "Entendido", title: '', text: parametros_paa.mensaje_validacion_4 });
      return;
    }
  
    //Si sobra liquido y no hay opcionales seleccionados
    if(liquido_pagar > 0 && ((dte_select_obligatorio.length > 0 && dte_select_no_obligatorio.length == 0) || (cxc_select_obligatorio.length > 0 && cxc_select_no_obligatorio.length == 0) || (cuotas_select_obligatorio.length > 0 && cuotas_select_no_obligatorio.length == 0))  
    ){
      // mensaje_validacion_5
      await fireAlert({ timer: 5000, icon: "success", button: "Entendido", title: '', text: parametros_paa.mensaje_info_1 });
      // return;
    }

    //Sin liquido a pagar y aplicaciones ( obligatorias y sin opcionales ).
    if( liquido_pagar == 0 && ((dte_select_obligatorio.length > 0 && dte_select_no_obligatorio.length == 0) || (cxc_select_obligatorio.length > 0 && cxc_select_no_obligatorio.length == 0) || (cuotas_select_obligatorio.length > 0 && cuotas_select_no_obligatorio.length == 0)) ){
      await fireAlert({ timer: 5000, icon: "success", button: "Entendido", title: '', text: parametros_paa.mensaje_info_2 });
    }

    //Llama a la funcion de continuar al paso 3
    handleSubmit();
  }
  //Valido si tiene obligartorias pendientes y si esas pendientes alcanza a pagar con el liquido a pagar disponible
  const validateappPendientes = ()=>{
    return new Promise((resolve, reject)=>{
      let text = false;
      if( rowsDoc.tempRows.length > 0){
        rowsDoc.tempRows.forEach((row) => {
          if( row.pagoTransito == 0 && row.obligatorio){
            if (
              parseFloat(row.abono) < (parseFloat(row?.saldoPendiente)+parseFloat(row.mora))
            ) {
              text = true;
            }
          }
        })
      } 
  
      if(rowsCxc.tempRows.length > 0){
        rowsCxc.tempRows.forEach((rowCxC) => {
          if( rowCxC.pagoTransito == 0 && rowCxC.obligatorio){
            if(  
              parseFloat(rowCxC.abono) < parseFloat(rowCxC?.saldo)
             ){
              text = true;
            }
          }
        });
      }
   
      if(rowsLeasing.tempRows.length > 0){
        rowsLeasing.tempRows.forEach((rowCL) => {
          if( rowCL.pago_transito == 0 && rowCL.obligatorio){
            if (
              parseFloat(rowCL.abono) < parseFloat(rowCL?.total_a_pagar)
            ) {
              text = true;
            }
          }
        });
      }

      resolve(text);

    })

  }

  const Formatt = ({ total }) => {
    return (
      <NumberFormat
        value={total}
        displayType={"text"}
        prefix={"$"}
        thousandSeparator={"."}
        decimalScale={0}
        decimalSeparator={","}
      />
    );
  };

  return (
    <>
      <ModalDesglose show={show} setShow={setShow} />
      { showSecciones &&  
        <Modalaplicaciones 
          show={showSecciones} 
          setShow={setShowSecciones}
          rowsDoc={rowsDoc}
          rowsCxc={rowsCxc}
          rowsLeasing={rowsLeasing}
          setselectAplicacionDoc={setselectAplicacionDoc}
          setselectAplicacionCxc={setselectAplicacionCxc}
          setselectAplicaionLeasing={setselectAplicaionLeasing}
          tiposeleccion={tiposeleccion} 
          setTiposeleccion={setTiposeleccion}
          showTables={showTables}
          totalAplicaciones={totalAplicaciones}
          handleSaveAplicaciones={handleSaveAplicaciones}
          parametros_paa={parametros_paa}
          handleCloseModal={handleCloseModal}
        />
      
      }
      <Table style={{ height: "293px" }}>
        <SkeletonTheme width="100px" height="20px">
          <thead
            style={{
              backgroundColor: "#eceaea",
              textAlign: "center",
            }}
          >
            <tr>
              <th colSpan={2}>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ gap: "5px" }}
                >
                  {text}
                  {reload ? (
                    <IconButton
                      Icon={
                        <AiOutlineCloudSync
                          size={25}
                          title="Recarga tus parametros comerciales."
                        />
                      }
                      onClick={onClick}
                    />
                  ) : null}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {bills.length > 1 ? "Monto documentos" : "Monto documento"}:
              </td>
              <td>
                {!loading ? <Formatt total={amountsObj.total} /> : <Skeleton />}
              </td>
            </tr>
            <tr>
              <td className="d-flex align-items-center">
                Monto no financiado
                <span
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    marginLeft: "0.1rem",
                  }}
                >
                  ({100 - (anticipo || ANTICIPO)}%)
                </span>
                :
              </td>
              <td>
                {!loading ? (
                  <Formatt total={amountsObj.nonFinanced} />
                ) : (
                  <Skeleton />
                )}
              </td>
            </tr>
            <tr>
              <td className="d-flex align-items-center">
                Monto anticipado{" "}
                <span
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    marginLeft: "0.1rem",
                  }}
                >
                  ({anticipo || ANTICIPO}%)
                </span>
                :
              </td>
              <td>
                {!loading ? (
                  <Formatt total={amountsObj.financed} />
                ) : (
                  <Skeleton />
                )}
              </td>
            </tr>
            <tr>
              <td>
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "5px" }}
                >
                  Costo Total:
                  <IconButton
                    Icon={
                      <BiHelpCircle size="20px" title="Ver mas detalles." />
                    }
                    onClick={() => setShow(true)}
                    disabled={loading}
                  />
                </div>
              </td>
              <td>
                {!loading ? <Formatt total={amountsObj.costs} /> : <Skeleton />}
              </td>
            </tr>
            {/* Aplicaciones  */}
            { (
                (parametros_paa.is_app_cxc && rowsCxc.tempRows.length > 0 ) || 
                (parametros_paa.is_app_dte && rowsDoc.tempRows.length > 0) || 
                (parametros_paa.is_app_lesing && rowsLeasing.tempRows.length > 0)
              ) &&
              <tr>
                <td>
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "5px" }}
                  >
                    { parametros_paa.etiqueta_aplicaciones }:
                    <IconButton
                      Icon={
                        <BiHelpCircle size="20px" title="Ver mas detalles." />
                      }
                      onClick={handleShowModal}
                      // || rowsDoc.rows.length == 0
                      disabled={loading }
                    />
                  </div>
                </td>
                <td>
                  {!loading ? <Formatt total={totalAplicacionestable} /> : <Skeleton />}
                </td>
              </tr>            
            }

            <tr>
              <td>Líquido a pagar:</td>
              <td>
                {!loading ? (
                  <Formatt total={(amountsObj.liquid - totalAplicacionestable)} />
                ) : (
                  <Skeleton baseColor="#a3a3a324" highlightColor="#ccc7c782" />
                )}
              </td>
            </tr>
          </tbody>
        </SkeletonTheme>
      </Table>

      <Button onClick={handleClickbutton} tableLoading={rows.length === 0 ? true : false} />
    </>
  );
};

export default Resumen;
